var exports = {
  "R": "MatureBlur.module__matureBlurred___ZHh2MG",
  "y": "MatureBlur.module__matureStickerBlurred___ZHh2MG",
};

module.exports = exports;
